import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { fetchDataAgnostic, postDataAgnostic } from 'Services/dataApi';
import { DepartmentContext } from 'DepartmentWrapper';
import { formatBearerToken } from 'Common.functions';
import { useAlert } from 'react-alert';
import style from './GenerateApplicationURLCode.style';
import { useAuth0 } from 'auth0/reactAuth0Spa';
import ApplicationForm from '../ApplicantProfile/ApplyPage/ApplicationForm/ApplicationForm';
import { faCopy, faEye, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';

const GenerateApplicationURLCode = (props) => {
  const [showFormPreview, setShowFormPreview] = useState(false);
  const [isGeneratingNewCode, setIsGeneratingNewCode] = useState(false);
  const [departmentApplicantData, setDepartmentApplicantData] = useState([]);
  const [baseUrl, setBaseUrl] = useState('');

  const [isFetchingDepartmentApplicantData, setIsFetchingDepartmentApplicantData] = useState(false);

  const { getTokenSilently } = useAuth0();
  const dContext = useContext(DepartmentContext);
  const alert = useAlert();

  useEffect(() => {
    fetchDepartmentApplicantData();
    const { protocol, hostname, port } = window.location;
    const newBaseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    setBaseUrl(newBaseUrl);
  }, []);

  const fetchDepartmentApplicantData = () => {
    setIsFetchingDepartmentApplicantData(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/application/list',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((res) => {
            setDepartmentApplicantData(res.data);
          })
          .catch((err) => {
            console.log('fetchDepartmentApplicantData err: ', err);
          })
          .finally(() => {
            setIsFetchingDepartmentApplicantData(false);
          });
      })
      .catch((err) => {
        setIsFetchingDepartmentApplicantData(false);
        console.log('getToken err: ', err);
      });
  };

  const generateNewCode = () => {
    setIsGeneratingNewCode(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/application/code',
          { pk_Department: dContext.department.pk_Department },
          null,
          formatBearerToken(token),
        )
          .then((result) => {
            console.log('app code result: ', result);
            setIsGeneratingNewCode(false);
            alert.success('New code generated successfully');
            fetchDepartmentApplicantData();
          })
          .catch((err) => {
            console.log('err: ', err);
            setIsGeneratingNewCode(false);
            alert.error('Failed to generate new code');
          });
      })
      .catch((err) => {
        setIsGeneratingNewCode(false);
        console.log('getToken err: ', err);
      });
  };

  const renderFormPreview = () => {
    return (
      <Modal
        isOpen={showFormPreview}
        toggle={() => setShowFormPreview(!showFormPreview)}
        size="lg"
        style={{ minWidth: '90vw' }}
      >
        <ModalHeader toggle={() => setShowFormPreview(!showFormPreview)}>Application Form Preview</ModalHeader>

        <ModalBody>
          <ApplicationForm isReadOnly={true} />
        </ModalBody>
      </Modal>
    );
  };

  const { Department = {} } = departmentApplicantData || {};

  return (
    <Card style={{ width: '100%' }}>
      <CardHeader style={{ fontWeight: 'bold' }}>
        <div style={{ ...style.simpleRow, justifyContent: 'space-between' }}>
          {' '}
          <div style={{ ...style.simpleColumn, width: 'auto' }}>Application URL </div>
          <div style={{ ...style.simpleColumn, width: 'auto' }}>
            <div style={{ ...style.simpleRow, justifyContent: 'space-between', alignItems: 'center' }}>
              <Button
                color="primary"
                size="sm"
                style={{ marginRight: 10 }}
                onClick={() => {
                  setShowFormPreview(true);
                }}
              >
                <FontAwesomeIcon icon={faEye} /> Preview Application Form
              </Button>

              <Button
                color="success"
                size="sm"
                onClick={() => {
                  navigator.clipboard.writeText(
                    `${baseUrl}/applicant/profile/new_application?applicationCode=${Department.ApplicantCode}`,
                  );
                  alert.success('URL copied to clipboard');
                }}
              >
                <FontAwesomeIcon icon={faCopy} /> Copy
              </Button>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        {/* <div style={{ ...style.simpleColumn, width: '100%', marginBottom: 10 }}>
          <div style={{ ...style.simpleRow, justifyContent: 'space-between', padding: 2 }}>
            <div
              style={{
                ...style.simpleColumn,
                width: 'auto',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
            >
              Application URL
            </div>
            <div style={{ ...style.simpleColumn, width: 'auto' }}>
              <div style={{ ...style.simpleRow, justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                  color="primary"
                  size="sm"
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    setShowFormPreview(true);
                  }}
                >
                  <FontAwesomeIcon icon={faEye} /> Preview Application Form
                </Button>

                <Button
                  color="success"
                  size="sm"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${baseUrl}/applicant/profile/new_application?applicationCode=${Department.ApplicantCode}`,
                    );
                    alert.success('URL copied to clipboard');
                  }}
                >
                  <FontAwesomeIcon icon={faCopy} /> Copy
                </Button>
              </div>
            </div>
          </div>
        </div> */}
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <Button
              disabled={isGeneratingNewCode}
              color="danger"
              size="sm"
              onClick={() => {
                Swal.fire({
                  title: 'Are you sure?',
                  text:
                    'This will generate a new code and invalidate the current one. Are you sure you want to proceed?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                }).then((result) => {
                  if (result.isConfirmed) {
                    generateNewCode();
                  }
                });
              }}
            >
              Generate New URL
              <FontAwesomeIcon icon={faRedoAlt} style={{ marginLeft: 10 }} />
            </Button>
          </InputGroupAddon>
          <Input
            type="text"
            size="sm"
            disabled={true}
            value={`${baseUrl}/applicant/profile/new_application?applicationCode=${Department.ApplicantCode}`}
            style={{ width: 300 }}
          />
        </InputGroup>
      </CardBody>
      {renderFormPreview()}
    </Card>
  );
};

export default GenerateApplicationURLCode;
